export default {
    error: 'Erro',
    wrongPassword: 'Senha incorreta',
}